import { CustomizerModel } from 'src/business/services/client.generated';
import { UmbracoImage } from 'src/core-lib/umbraco/umbraco-image.model';

export namespace StorageUtil {
    export function set<T>(key: string, value: T) {
        sessionStorage.setItem(key, JSON.stringify(value));
    }
    export function get<T>(key: string): T {
        return JSON.parse(sessionStorage.getItem(key)) as T;
    }
    export function remove(key: string): void {
        sessionStorage.removeItem(key);
    }
    export namespace Remember {
        export function set<T>(key: string, value: T) {
            localStorage.setItem(key, JSON.stringify(value));
        }
        export function get<T>(key: string): T {
            return JSON.parse(localStorage.getItem(key)) as T;
        }
        export function remove(key: string): void {
            localStorage.removeItem(key);
        }
    }
}

export namespace PageUtils {
    export function fallbackImg() {
        var result = StorageUtil.get<{ theme: { fallbackUrl: UmbracoImage } }>('system');
        return result.theme.fallbackUrl;
    }

    export async function loadSearchLink() {
        var result = StorageUtil.get<{ searchPageLink: string }>('system');
        return new URL(result.searchPageLink, window?.location?.origin);
    }

    export async function loadBasketLink() {
        var result = StorageUtil.get<{ basketPageLink: string }>('checkout');
        return new URL(result.basketPageLink, window?.location?.origin);
    }
    export async function loadCheckoutLink() {

        var result = StorageUtil.get<{ checkoutPageLink: string }>('checkout');
        return new URL(result.checkoutPageLink, window?.location?.origin);
    }
}

export namespace ContentCacheUtils {
    export function system<T>() {
        return StorageUtil.get<T>('system');
    }
    export function checkout<T>() {
        return StorageUtil.get<T>('checkout');
    }
    export function languages<T>() {
        return StorageUtil.get<T>('languages');
    }
    export function menu<T>() {
        return StorageUtil.get<T>('menu');
    }
    export function page<T>() {
        return StorageUtil.get<T>('page');
    }
    export function scripts<T>() {
        return StorageUtil.get<T>('scripts');
    }
    export function routing() {
        return StorageUtil.get<{ [key: string]: string }>('routing') ?? {};
    }
    export function translations<T>() {
        return StorageUtil.get<T>('translations');
    }
}


export namespace ProductStore {
    export function clear() {
        StorageUtil.remove('PRODUCT');
    }

    export function set(customizer: CustomizerModel) {
        StorageUtil.set('PRODUCT', customizer);
    }

    export function get(): CustomizerModel {
        return StorageUtil.get<CustomizerModel>('PRODUCT');
    }
}
